// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2xOIj","row":"Node_row__34ygo","label":"Node_label__12jKz","footer":"Node_footer__3AHwn"};